"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import React from "react";

const CountryCostOfStudying: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const sectionData = country?.costOfStudying;

  const tableRows = sectionData?.tuitionTable || [];

  if (tableRows.length === 0) {
    return null;
  }

  const heading =
    sectionData?.heading || `Cost of Studying in ${country.countryName}`;
  const subheading =
    sectionData?.subheading ||
    "Tuition varies by degree level, subject, and university tier. Here's what to budget for.";
  const disclaimerText = sectionData?.disclaimerText;

  const exclusionsTitle = sectionData?.exclusionsNote?.title;
  const exclusionsDesc = sectionData?.exclusionsNote?.description;

  return (
    <div className="w-full my-12 space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2233] ff_poppins">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-1.5 text-xs sm:text-sm text-[#667085] ff_poppins">
            {subheading}
          </p>
        )}
      </div>

      {/* TABLE */}
      <div className="rounded-[18px] overflow-hidden border border-[#E0D8FF] bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#0A1629] text-white uppercase text-xs sm:text-sm font-semibold tracking-wider">
                <th className="py-4 px-6">Degree Type</th>
                <th className="py-4 px-6">Duration</th>
                <th className="py-4 px-6">Average Annual Tuition</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-xs sm:text-sm text-[#333E5C] ff_poppins font-medium">
              {tableRows.map((row, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-[#FBF9FF]"}
                >
                  <td className="py-4 px-6 font-semibold text-[#1C2233]">
                    {row.degreeType}
                  </td>
                  <td className="py-4 px-6 text-[#525B73]">{row.duration}</td>
                  <td className="py-4 px-6 font-bold text-[#0A1629]">
                    {row.averageTuition}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* FOOTNOTE */}
      {disclaimerText && (
        <p className="text-xs text-[#667085] italic ff_poppins">{disclaimerText}</p>
      )}

      {/* EXCLUSIONS CALLOUT BOX */}
      {(exclusionsTitle || exclusionsDesc) && (
        <div className="bg-gradient-to-r from-[#FFF5F2] to-[#FFF9F5] border border-[#FFDCD2] rounded-[18px] p-6 sm:p-7 shadow-xs">
          {exclusionsTitle && (
            <h4 className="text-sm sm:text-base font-bold text-[#1C2233] ff_poppins mb-1.5">
              {exclusionsTitle}
            </h4>
          )}
          {exclusionsDesc && (
            <p className="text-xs sm:text-sm text-[#525B73] ff_poppins leading-relaxed">
              {exclusionsDesc}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CountryCostOfStudying;

